import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import * as css from "./Paper.module.css"

function Paper({ children, elevation, padded, hero, hoverable, className }) {
  return (
    <div
      className={cx(
        css.root,
        {
          [css.padded]: padded,
          [css.elevation0]: elevation === 0,
          [css.hero]: hero,
          [css.hover]: hoverable,
        },
        className
      )}
    >
      {children}
    </div>
  )
}

Paper.propTypes = {
  children: PropTypes.node,
  elevation: PropTypes.number,
  padded: PropTypes.bool,
  className: PropTypes.string,
  hero: PropTypes.bool,
  hoverable: PropTypes.bool,
}

export default Paper
